export default {
    props: {
        onlyNumber: {
            type: Boolean,
        },

        onlyNumeric: {
            type: Boolean,
        },
    },

    data() {
        return {
            innerValue: this.value
        }
    },

    watch: {
        value(newValue) {
            this.innerValue = newValue;
        }
    },

    computed: {
        valueLength() {
            return this.innerValue && '' + this.innerValue.length || 0;
        },

        isAddZeroClass() {
            return !this.valueLength;
        },

        isShowPlaceholder() {
            return !this.valueLength;
        },

        listeners() {
            return {
                ...this.$listeners,
                input:event => {
                    const nextValue = this.getNextValue(event.target.value);
                    this.innerValue = nextValue;
                    this.$emit('input', nextValue);
                },
                change:event => {
                    const nextValue = this.getNextValue(event.target.value, true);
                    this.$emit('change', nextValue);
                    this.$emit('input', nextValue);
                }
            }
        },
    },

    methods: {
        focus() {
            this.$refs.input.focus();
        },

        getValue() {
            return this.getNextValue(this.$refs.input.value);
        },

        getNextValue(newValue, trim) {
            let resultValue = '' + newValue;

            const originLength = resultValue.length;
            const pos = this.$refs.input.selectionStart;

            if (trim) {
                resultValue = resultValue.trim();
            }

            if (this.onlyNumber || this.onlyNumeric) {
                resultValue = resultValue.replace(/[^\d]/g, '');

                if (resultValue.length) {
                    if (this.onlyNumber) {
                        resultValue = Number(resultValue);
                    }
                } else {
                    resultValue = undefined;
                }
            }

            const resultLength = ('' + resultValue).length;

            if (resultLength !== originLength) {
                const diff =  originLength - resultLength;
                this.$refs.input.value = resultValue || '';
                this.$refs.input.setSelectionRange(pos - diff, pos - diff);
            }

            return resultValue;
        }
    }
}
